import moment from 'moment';
import { DATE_TIME_IN_YYYY_MM_DD_FORMAT } from '../features/shared-components/chart/constants/eventLabellingChartConstants';

export const sleep = milliseconds => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export const validateEmail = text => {
  const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  return reg.test(text);
};

export const MINIMUM_PASSWORD_LENGTH = 8;
export const MAXIMUM_PASSWORD_LENGTH = 64;
export const isPasswordValid = text => {
  return (text.length >= MINIMUM_PASSWORD_LENGTH && text.length <= MAXIMUM_PASSWORD_LENGTH);
}

export const convertTimestampToTime = timestamp => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const date = new Date(timestamp);
  const year = date.getFullYear().toString();
  const day = date.getDate();
  const hour = ('0' + date.getHours()).slice(-2);
  const minute = ('0' + date.getMinutes()).slice(-2);
  const second = ('0' + date.getSeconds()).slice(-2);
  const dateString = `${day} ${months[date.getMonth()]} ${year}, ${hour}:${minute}:${second}`;
  return dateString;
};

export const DEFAULT_SARCASM_THRESHOLD = 0.5;
export const calculateSarcasmThreshold = function() {
  const env_var_value_sarcasm_threshold = process.env.REACT_APP_SARCASM_THRESHOLD;
  let sarcasmThreshold = DEFAULT_SARCASM_THRESHOLD;
  if (env_var_value_sarcasm_threshold) {
    return parseFloat(env_var_value_sarcasm_threshold);
  }
  return sarcasmThreshold;
};

export const calculateIfSarcasmIsEnabled = function() {
  const env_var_value = process.env.REACT_APP_IS_SARCASM_ENABLED;
  let isSarcasmEnabled = false;
  if (!env_var_value || env_var_value.toString().toLocaleLowerCase() === 'true') {
    return true;
  }
  return isSarcasmEnabled;
};

export const calculateHarmWatchFromDate = function() {
  const env_var_value_harm_watch_from_date = process.env.REACT_APP_HARM_WATCH_FROM_DATE;
  let harmWatchFromDate = moment().subtract(6, 'days').format(DATE_TIME_IN_YYYY_MM_DD_FORMAT);
  if (env_var_value_harm_watch_from_date) {
    return env_var_value_harm_watch_from_date.toString();
  }
  return harmWatchFromDate;
};

export const calculateHarmWatchToDate = function() {
  const env_var_value_harm_watch_to_date = process.env.REACT_APP_HARM_WATCH_TO_DATE;
  let harmWatchToDate = moment().format(DATE_TIME_IN_YYYY_MM_DD_FORMAT);
  if (env_var_value_harm_watch_to_date) {
    return env_var_value_harm_watch_to_date.toString();
  }
  return harmWatchToDate;
};

export const areTruescopeSourcesEnabled = function() {
  const env_var_value = process.env.REACT_APP_ARE_TRUESCOPE_SOURCES_ENABLED;
  return !env_var_value || env_var_value.toString().toLocaleLowerCase() === 'true';
}


// WEBPACK FOOTER //
// ./src/common/globalUtils.js